<template>
  <div>
    <my-header></my-header>
  
    <div class="content-container-level-1">
      <h2>New user</h2>

      <form @submit.prevent="addUser">
        <div class="form-group">
          <label for="first-name">First name</label>
          <input id="first-name" v-model="firstName" class="form-control" maxlength="100" required v-focus>
        </div>

        <div class="form-group">
          <label for="last-name">Last name</label>
          <input id="last-name" v-model="lastName" class="form-control" maxlength="100" required>
        </div>

        <div class="form-group">
          <label for="login">Login</label>
          <input v-model="login" id="login" class="form-control" maxlength="30" required>
        </div>

        <div class="form-group">
          <label for="role-selector">Role</label>
          <select v-model="role" id="role-selector" class="form-control" required>
            <option :value="ROLE_ADMIN">{{ROLE_ADMIN | getRoleName}}</option>
            <option :value="ROLE_MODERATOR">{{ROLE_MODERATOR | getRoleName}}</option>
            <option :value="ROLE_READER">{{ROLE_READER | getRoleName}}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            class="form-control"
            maxlength="100"
            autocomplete="off"
            required
          >
        </div>

        <b-button :to="{name: 'users'}">Cancel</b-button>
        <b-button type="submit" variant="primary">Register</b-button>
      </form>
    </div>

  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';
import MyHeader from './Header.vue';

import { ROLE_ADMIN     } from '../util';
import { ROLE_MODERATOR } from '../util';
import { ROLE_READER    } from '../util';

export default {
  name: 'UserAdd',

  components: {
    MyHeader,
  },

  data() {
    return {
      ROLE_ADMIN,
      ROLE_MODERATOR,
      ROLE_READER,

      firstName: '',
      lastName: '',
      login: '',
      role: null,
      password: '',
    };
  },

  methods: {
    addUser() {
      notifier.deleteSenderNotifications(this);

      const trimmedFirstName = this.firstName.trim();
      if(trimmedFirstName.length === 0) {
        notifier.showError(
          'First name must be specified.',
          {sender: this}
        );
        return;
      }

      const trimmedLastName = this.lastName.trim();
      if(trimmedLastName.length === 0) {
        notifier.showError(
          'Last name must be specified.',
          {sender: this}
        );
        return;
      }

      const trimmedLogin = this.login.trim();
      if(trimmedLogin.length === 0) {
        notifier.showError(
          'Login must be specified.',
          {sender: this}
        );
        return;
      }

      const data = new FormData();
      data.append('first_name', trimmedFirstName);
      data.append('last_name', trimmedLastName);
      data.append('login', trimmedLogin);
      data.append('role', this.role);
      data.append('password', this.password);

      HTTP.post('/user/add', data)
      .then(response => {
        const result = response.data.result.code;

        const RESULT_SUCCESS       = 1;
        const RESULT_NO_PERMISSION = 2;

        if(result === RESULT_SUCCESS) {
          notifier.showSuccessAfterTransition('User added.');
          this.$router.push({name: 'users'});
          return;
        }

        if(result === RESULT_NO_PERMISSION) {
          notifier.showError('No permission', {sender: this});
          return;
        }

        notifier.showError(`Unknown result code ${result}.`, {sender: this});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
